import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 25,
	viewBox: "0 0 40 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 2.27273C0 1.01753 1.00837 0 2.25225 0H37.7477C38.9916 0 40 1.01753 40 2.27273V22.7273C40 23.9825 38.9916 25 37.7477 25H2.25225C1.00837 25 0 23.9825 0 22.7273V2.27273Z",
			fill: "#3C404A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3964 12.2626C21.3964 15.3309 18.8755 17.8182 15.7658 17.8182C12.6561 17.8182 10.1351 15.3309 10.1351 12.2626C10.1351 9.19436 12.6561 6.70705 15.7658 6.70705C18.8755 6.70705 21.3964 9.19436 21.3964 12.2626Z",
			fill: "#F56436"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8423 12.2626C29.8423 15.3309 27.3214 17.8182 24.2117 17.8182C21.102 17.8182 18.5811 15.3309 18.5811 12.2626C18.5811 9.19436 21.102 6.70705 24.2117 6.70705C27.3214 6.70705 29.8423 9.19436 29.8423 12.2626Z",
			fill: "#FFC635"
		})
	]
});
export default SvgMc;
